import { render, staticRenderFns } from "./BalancesTable.vue?vue&type=template&id=51f6d836&scoped=true"
import script from "./BalancesTable.vue?vue&type=script&lang=js"
export * from "./BalancesTable.vue?vue&type=script&lang=js"
import style0 from "./BalancesTable.vue?vue&type=style&index=0&id=51f6d836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f6d836",
  null
  
)

export default component.exports